<template>
	<AppModal :settings="settings">
		<PrivacyModalContent />
	</AppModal>
</template>

<script>
import AppModal from '@/components/App/AppModal';
import PrivacyModalContent from './PrivacyModalContent';

export default {
	components: {
		AppModal,
		PrivacyModalContent,
	},
	data() {
		return {
			settings: {
				name: 'modalPrivacy',
				title: '개인정보 처리 방침',
				isOpen: true,
			},
		};
	},
};
</script>
